<template>
    <div class="dc-background">
        <div class="bg-connect" />
        <div class="bg-gradient" />
        <b-container>
            <b-row class="justify-content-center fullheight">
                <b-col
                    md="7"
                    align-self="center"
                >
                    <b-card-group>
                        <b-card
                            no-body
                            no-gutters
                            class="p-4"
                        >
                            <b-card-body>
                                <b-form>
                                    <h3>Register</h3>
                                    <p class="text-muted">
                                        Sign up for ClioVis
                                    </p>
                                    <b-form @keydown="keypress">
                                        <b-input-group class="mb-3">
                                            <b-input-group-prepend><b-input-group-text><i class="fas fa-user" /></b-input-group-text></b-input-group-prepend>
                                            <b-form-input
                                                v-model="formData.username"
                                                type="text"
                                                class="form-control"
                                                placeholder="Username"
                                                autocomplete="username"
                                            />
                                        </b-input-group>
                                        <b-input-group class="mb-3">
                                            <b-input-group-prepend><b-input-group-text><i class="fas fa-envelope" /></b-input-group-text></b-input-group-prepend>
                                            <b-form-input
                                                v-model="formData.email"
                                                type="text"
                                                class="form-control"
                                                placeholder="Email Address"
                                                autocomplete="email"
                                            />
                                        </b-input-group>
                                        <b-input-group class="mb-4">
                                            <b-input-group-prepend><b-input-group-text><i class="fas fa-lock" /></b-input-group-text></b-input-group-prepend>
                                            <b-form-input
                                                v-model="formData.password"
                                                :type="passwordInputType"
                                                class="form-control"
                                                placeholder="Password"
                                                autocomplete="current-password"
                                            />
                                            <b-form-input
                                                v-model="formData.confirmPassword"
                                                :type="passwordInputType"
                                                class="form-control"
                                                placeholder="Confirm Password"
                                                autocomplete="current-password"
                                            />
                                            <b-input-group-append style="position: absolute; right: 0; z-index: 100">
                                                <b-btn
                                                    variant="Transparent"
                                                    style="padding-top: 7px; width: 48px"
                                                    aria-label="show or hide password"
                                                    @click="clickPasswordInputType()"
                                                >
                                                    <i
                                                        :class="passwordInputType == 'password' ? 'fas fa-eye' : 'fas fa-eye-slash'"
                                                        style="font-size: 20px; color: #182e52"
                                                    />
                                                </b-btn>
                                            </b-input-group-append>
                                        </b-input-group>
                                        <b-row no-gutters>
                                            <b-col md="auto">
                                                <b-button
                                                    v-if="!attemptingLogin"
                                                    variant="cliovis-blue-light"
                                                    class="px-4"
                                                    style="font-weight: 500"
                                                    @click="clickRegister"
                                                >
                                                    Register
                                                </b-button>
                                                <b-button
                                                    v-else
                                                    variant="outline-liovis-blue-light"
                                                    class="px-4"
                                                    style="font-weight: 500"
                                                >
                                                    Register
                                                </b-button>

                                                <b-button
                                                    class="px-4"
                                                    style="margin-left: 5px; font-weight: 500"
                                                    @click="clickCancel"
                                                >
                                                    Cancel
                                                </b-button>
                                            </b-col>
                                        </b-row>
                                    </b-form>
                                </b-form>
                            </b-card-body>
                            <div
                                v-for="error in errors"
                                :key="error.message"
                            >
                                <b-alert
                                    show
                                    :variant="error.variant ? error.variant : 'warning'"
                                >
                                    {{ error.message }}
                                </b-alert>
                            </div>
                        </b-card>
                        <!--
							<b-card no-body class="text-white bg-primary py-5 d-md-down-none" style="width:44%">
								<b-card-body class="text-center">
									<div>
										<h2>Sign up</h2>
										<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
										<b-button variant="primary" class="active mt-3">Register Now!</b-button>
									</div>
								</b-card-body>
							</b-card>
							-->
                    </b-card-group>
                </b-col>
            </b-row>
            <b-row
                align-h="end"
                class="text-center py-3"
                style="font-size: 14px"
            >
                <!-- <b-col cols="4"><b-btn href="https://cliovis.com/support-us/" target="_blank" variant="cliovis-grey-extraDark" pill class="button-rightside" style="min-height: 32px; line-height: 16px; margin-top: -10px"><i class="fas fa-heart"/> Support Us</b-btn></b-col> -->
                <b-col cols="4">
                    &copy; 2024 Copyright: <a
                        href="https://cliovis.com"
                        target="_blank"
                        style="color: #24457a; font-weight: 700"
                    ><span style="color: #396aba"> Clio</span>Vis, LLC</a>
                </b-col>
                <b-col
                    cols="4"
                    class="text-right"
                >
                    ClioVis {{ VersionString }}
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script lang="js">
import { VersionString } from '@/constants/environment';

export default {
    name: 'Login',
    data()
    {
        return {
            attemptingLogin: false,
            passwordInputType: "password",
            redirect: "/",
            errors: [],
            formData: 
			{
			    username: "",
			    email: "",
			    password: "",
			    confirmPassword: ""
			}
        };
    },
    computed: {
    	VersionString() 
        {
        	return VersionString;
    	}
    },
    methods: {
        keypress(evt)
        {
            // form submit doesn't seem to work here for some reason,
            // so we just listen for keypress w/ Enter 
            if (evt.key == "Enter")
            {
                this.clickRegister();
            }
        },

        async clickRegister()
        {
            // easiest way to clear array
            this.errors.length = 0;
            if (this.formData.password != this.formData.confirmPassword)
            {
                this.errors.push({message: "Passwords do not match", variant:"danger"});
                return;
            }

    		this.redirect = this.$route.query.redirect || this.redirect;
            this.attemptingLogin = true;
            let form = new FormData();
            form.append('user', this.formData.username);
            form.append('email', this.formData.email);
            form.append('pass', this.formData.password);
            
            try 
            {
                let res = await this.$http.post('createaccount', form);
                if (res.data.error)
                {
                    this.errors.push({message: res.data.error, variant:"danger"});
                    this.attemptingLogin = false;
                    return;
                }
                alert(res.data.result);
                this.$router.push('/login');
            }
            catch (error) 
            {
                let res = error.response;
                if (res.data.error)
                {
                    this.errors.push({message: res.data.error, variant:"danger"});
                    this.attemptingLogin = false;
                    return;
                }
            }
            this.attemptingLogin = false;
        },

        clickCancel()
        {
            this.$router.push('/login');
        },

        clickForgotPassword()
        {
            this.errors.length = 0;
            this.errors.push({message: "Not implemented", variant:"danger"});
        },

        clickPasswordInputType()
        {
            if(this.passwordInputType == "password")
            {
                this.passwordInputType = "text";
            }
            else
            {
                this.passwordInputType = "password";
            }
        },
    }
};
</script>

<style lang="scss" scoped>
.login-background
{
	width: 100vw;
	height: 100vh;
	background-color: #E4E5E6 !important;
	
	/*
	background-color: #FFFFFF !important;
	background-image: url("../assets/images/connections_background.jpg") !important;
	background-attachment: fixed;
	background-size: contain;
	background-repeat: no-repeat;
	background-position-x: right;
	//*/

	display: flex;
	vertical-align: middle;
	align-content: center;
}

.fullheight
{
	height: 93vh;
	min-height: 380px;
}
</style>